export default "__VITE_ASSET__244e226e__"